import { Component, EventEmitter, Inject, inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, FormControl, UntypedFormGroup, FormArray } from '@angular/forms';
import { AppStateService } from '../app-state.service';
import { TypZaznamuTextu } from '../model/typ-zaznamu-textu';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ZaverecnePraceDialogComponent } from '../zaverecne-prace-dialog/zaverecne-prace-dialog.component';
import { ProfiloveAOstatneZabezpecovanePredmetyDialogComponent } from '../profilove-a-ostatne-zabezpecovane-predmety-dialog/profilove-a-ostatne-zabezpecovane-predmety-dialog.component';
import { Predmet } from '../model/predmet';

interface DialogResult {
    pocetBakalarskychPrac: number;
    pocetDiplomovychPrac: number;
    pocetDizertacnychPrac: number;
}

@Component({
    selector: 'app-nadpis-blok-sekcia-druh',
    templateUrl: './nadpis-blok-sekcia-druh.component.html',
    styleUrls: ['./nadpis-blok-sekcia-druh.component.css'],
    standalone: false
})
export class NadpisBlokSekciaDruhComponent implements OnInit {

  readonly NADPIS: number = 1;
  readonly BLOK: number = 2;
  readonly SEKCIA: number = 3;
  readonly POLOZKA: number = 4;

  readonly SELECT: number = 3;

  readonly ID_TYP_POCET_AKTUALNE_VEDENYCH_PRAC = -60;
  readonly ID_TYP_POCET_VEDENYCH_PRAC_BAKALARSKYCH = -61;
  readonly ID_TYP_POCET_VEDENYCH_PRAC_DIPLOMOVYCH = -62;
  readonly ID_TYP_POCET_VEDENYCH_PRAC_DIZERTACNYCH = -63;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC = -64;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH = -110;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH_EVIDOVANYCH_V_AiS2 = -111;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH = -114;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH_EVIDOVANYCH_V_AiS2 = -115;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH = -118;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH_EVIDOVANYCH_V_AiS2 = -119;


  //TODO: dat prec tu -1
  readonly ZOZNAM_ID_TYPOV_ZP_S_PREDVYPLNENIM: number[] = [
		this.ID_TYP_POCET_AKTUALNE_VEDENYCH_PRAC,
		this.ID_TYP_POCET_OBHAJENYCH_PRAC,
		this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH,
		this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH,
		this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
    // ,-1 // TESTOVACIA -1
	];

  readonly ZOZNAM_ID_TYPOV_OBHAJENYCH_PRAC = [
        this.ID_TYP_POCET_OBHAJENYCH_PRAC,
        this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH,
        this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH,
        this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
      ];

  readonly ID_TYP_PREHLAD_ZABEZPECOVANYCH_PROFILOVYCH_PREDMETOV = -47;
  readonly ID_TYP_PREHLAD_ZABEZPECOVANYCH_OSTATNYCH_PREDMETOV = -68;

  readonly ZOZNAM_ID_TYPOV_PREDMETOV_S_VYPLNENIM = [
    this.ID_TYP_PREHLAD_ZABEZPECOVANYCH_PROFILOVYCH_PREDMETOV,
    this.ID_TYP_PREHLAD_ZABEZPECOVANYCH_OSTATNYCH_PREDMETOV
  ]

  readonly ZOZNAM_ID_TYPOV_S_PREDVYPLNENIM = [
    ...this.ZOZNAM_ID_TYPOV_ZP_S_PREDVYPLNENIM,
    ...this.ZOZNAM_ID_TYPOV_PREDMETOV_S_VYPLNENIM
  ]

  // 1 - nadpis, 2 - blok, 3 - sekcia
  @Input() idDruhZaznamuTextu!: number;

  // "SK"; "EN"; "SK, EN"
  /**kodJazyk moze nadobudat hodnoty napr. "SK", "EN" alebo "SK, EN" (cize aj kombinaciu jazykov) */
  @Input() kodJazyk!: string;
  @Input() kodJazykRadiobox!: string;
  @Input() typZaznamuTextu!: TypZaznamuTextu;
  @Input() formularFormGroup!: UntypedFormGroup;
  @Input() pocetTypovVSkupine!: number;

  // "mapaIdSkupinACastiSkupin" potrebujeme pouzit v pri skupinovom opakovani v metode,
  // kde volame (emitujeme) metodu "pridatSkupinoveOpakovanie" z formular.component.ts
  // @Input() mapaIdSkupinACastiSkupin!: Map<number, number[]>;
  @Input() mapaJazykovAMapIdSkupinACastiSkupin!: Map<string, Map<number, number[]>>;



  @Output() pridatSkupinoveOpakovanie = new EventEmitter<string>();


  zobrazitHelpTextJazyk1 = false;
  zobrazitHelpTextJazyk2 = false;
  zobrazitHelpTextJazyk3 = false;

  pocetPoloziekSK: number = 0;
  pocetPoloziekEN: number = 0;
  pocetPridanychPoloziekSK: number = 0;
  pocetPridanychPoloziekEN: number = 0;

  typyZaznamovTextuPreSkupinu: TypZaznamuTextu[] = [];

  jazykyFormularaPole: string[] = [];
  jazykFormulara1 = 'SK';
  jazykFormulara2 = '';
  jazykFormulara3 = '';
  existujeVoFormulariJazyk2 = false;
  existujeVoFormulariJazyk3 = false;

  dialog = inject(MatDialog);

  private dialogRef: MatDialogRef<ZaverecnePraceDialogComponent, DialogResult>;
  private dialog2Ref: MatDialogRef<ProfiloveAOstatneZabezpecovanePredmetyDialogComponent, Predmet[]>;

  constructor(public appStateService: AppStateService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {

    this.jazykyFormularaPole = this.appStateService.jazykyFormulara;
    this.jazykFormulara1 = this.jazykyFormularaPole[0];
    if (this.jazykyFormularaPole.length >= 2) {
      this.jazykFormulara2 = this.jazykyFormularaPole[1];
      this.existujeVoFormulariJazyk2 = true;
    }
    if (this.jazykyFormularaPole.length >= 3) {
      this.jazykFormulara3 = this.jazykyFormularaPole[2];
      this.existujeVoFormulariJazyk3 = true;
    }

  }

  skopirovatTextVJazyku1doOstatnychJazykov() {
    const nameJazyk1 =  'name_'+ this.typZaznamuTextu.idSkupina + '_' + this.jazykFormulara1;
    const nameJazyk2 = 'name_'+ this.typZaznamuTextu.idSkupina + '_' + this.jazykFormulara2;
    const nameJazyk3 = 'name_'+ this.typZaznamuTextu.idSkupina + '_' + this.jazykFormulara3;

    const controlJazyk1 = this.formularFormGroup.get(nameJazyk1);
    let textPolozkyJazyk1 = controlJazyk1 ? controlJazyk1.value : '';
    // console.log('Text polozky na kopirovanie: ' + textPolozkyJazyk1);

    // v pripade comboboxu skopirujeme text do EN tak,
    // ze nastavime z polozkyCiselnikaJazyk2 polozku na rovnakej pozicii, ako je v SK ciselniku

    const formArray = <UntypedFormArray>this.formularFormGroup.get(nameJazyk1);
    let poleNaKopirovanieJazyk2 = [];
    let poleNaKopirovanieJazyk3 = [];

    // SKUPINOVE POLOZKY
    for (let index = 0; index < formArray.length; index++) {
      const polozkaControl = formArray.get(index.toString());
      if (!polozkaControl) {
        continue;
      }
      textPolozkyJazyk1 = polozkaControl.value;

      if (this.typZaznamuTextu.idTypObjektu === this.SELECT) {
        for (let i = 0; i < this.typZaznamuTextu.polozkyCiselnika.length; i++) {
          const polozka = this.typZaznamuTextu.polozkyCiselnika[i];
          if (polozka === textPolozkyJazyk1) {
            // kontrolou na rovnaku dlzku poli sa ubezpecime, ze index "i" existuje aj v ciselniku jazyka 2 a 3 a
            // ze ciselniky maju rovnaku velkost, a teda su zrejme prelozene vsetky polozky
            if (this.existujeVoFormulariJazyk2 &&
                this.typZaznamuTextu.polozkyCiselnika.length === this.typZaznamuTextu.polozkyCiselnikaJazyk2.length) {

              poleNaKopirovanieJazyk2.push(this.typZaznamuTextu.polozkyCiselnikaJazyk2[i]);
            }

            if (this.existujeVoFormulariJazyk3
                && this.typZaznamuTextu.polozkyCiselnika.length === this.typZaznamuTextu.polozkyCiselnikaJazyk3.length) {

              poleNaKopirovanieJazyk3.push(this.typZaznamuTextu.polozkyCiselnikaJazyk3[i]);
            }
            break;
          }
        }

      } else {
        if (this.existujeVoFormulariJazyk2) {
          poleNaKopirovanieJazyk2.push(polozkaControl.value);
        }
        if (this.existujeVoFormulariJazyk3) {
          poleNaKopirovanieJazyk3.push(polozkaControl.value);
        }
      }

      if (this.existujeVoFormulariJazyk2) {
        this.formularFormGroup.patchValue({[nameJazyk2] : poleNaKopirovanieJazyk2});
      }
      if (this.existujeVoFormulariJazyk3) {
        this.formularFormGroup.patchValue({[nameJazyk3] : poleNaKopirovanieJazyk3});
      }

    }

  }

  getNeplatnaPolozkaTooltip(): string {
    return this.translateService.instant('Aktuálne neplatná položka dokumentu');
  }

  getPopisJazyk(kodJazyk: string) {

    let result = null;
    switch (kodJazyk) {
      case this.jazykFormulara1:
        result = this.typZaznamuTextu.popis
        break;
      case this.jazykFormulara2:
        result = this.typZaznamuTextu.popisJazyk2
        break;
      case this.jazykFormulara3:
        result = this.typZaznamuTextu.popisJazyk3
        break;

      default:
        break;
    }

    return result;
  }

  getKodAPopis(jazyk: string) {
    let result = '';
    switch (jazyk) {
      case this.jazykFormulara1:
        if (this.typZaznamuTextu.kod) {
          result += this.typZaznamuTextu.kod + ' ';
        }
        if (this.typZaznamuTextu.popis) {
          result += this.typZaznamuTextu.popis;
        }
        // result = this.typ.kod ? this.typ.kod : '' + ' ' + this.typ.popis ? this.typ.popis : '';
        break;

      case this.jazykFormulara2:
        if (this.typZaznamuTextu.kodJazyk2) {
          result += this.typZaznamuTextu.kodJazyk2 + ' ';
        }
        if (this.typZaznamuTextu.popisJazyk2) {
          result += this.typZaznamuTextu.popisJazyk2;
        }
        break;

      case this.jazykFormulara3:
        if (this.typZaznamuTextu.kodJazyk3) {
          result += this.typZaznamuTextu.kodJazyk3 + ' ';
        }
        if (this.typZaznamuTextu.popis) {
          result += this.typZaznamuTextu.popisJazyk3;
        }
        break;

      default:
        break;
    }
    return result;
  }

  getVysvetlivka(jazyk: string) {
    let result = null;
    switch (jazyk) {
      case this.jazykFormulara1:
        result = this.typZaznamuTextu.vysvetlivka;
        break;
      case this.jazykFormulara2:
        result = this.typZaznamuTextu.vysvetlivkaJazyk2;
        break;
      case this.jazykFormulara3:
        result = this.typZaznamuTextu.vysvetlivkaJazyk3;
        break;

      default:
        break;
    }
    return result;
  }

  getDoplnPopisCely(jazyk: string) {
    let result = null;
    switch (jazyk) {
      case this.jazykFormulara1:
        result = this.typZaznamuTextu.doplnPopisCely;
        break;
      case this.jazykFormulara2:
        result = this.typZaznamuTextu.doplnPopisCelyJazyk2;
        break;
      case this.jazykFormulara3:
        result = this.typZaznamuTextu.doplnPopisCelyJazyk3;
        break;

      default:
        break;
    }
    return result;
  }

  zmenitZobrazenieHelpTextu(jazyk: string) {
    switch (jazyk) {
      case this.jazykFormulara1:
        this.zobrazitHelpTextJazyk1 = !this.zobrazitHelpTextJazyk1;
        break;
      case this.jazykFormulara2:
        this.zobrazitHelpTextJazyk2 = !this.zobrazitHelpTextJazyk2;
        break;
      case this.jazykFormulara3:
        this.zobrazitHelpTextJazyk3 = !this.zobrazitHelpTextJazyk3;
        break;

      default:
        break;
    }
  }

  zobrazitHelpText(jazyk: string) {
    let result : boolean = false;
    switch (jazyk) {
      case this.jazykFormulara1:
        result = this.zobrazitHelpTextJazyk1;
        break;
      case this.jazykFormulara2:
        result = this.zobrazitHelpTextJazyk2;
        break;
      case this.jazykFormulara3:
        result = this.zobrazitHelpTextJazyk3;
        break;

      default:
        break;
    }
    return result;
  }


  openDialogNaPredvyplnenieUdajov() {

    if (this.ZOZNAM_ID_TYPOV_S_PREDVYPLNENIM.includes(this.typZaznamuTextu.id)) {

      if (this.ZOZNAM_ID_TYPOV_ZP_S_PREDVYPLNENIM.includes(this.typZaznamuTextu.id)) {
        this.openZaverecnePraceDialog();
      } else if (this.ZOZNAM_ID_TYPOV_PREDMETOV_S_VYPLNENIM.includes(this.typZaznamuTextu.id)) {
        this.openZabezpecovanePredmetyDialog();
      }

    }

  }


  openZaverecnePraceDialog(typPrace?: string) {

    // let typZobrazovanychDat = '';

    // const title = this.translateService.instant('Vedené záverečné práce evidované v AiS2');

    this.dialogRef = this.dialog.open(
        ZaverecnePraceDialogComponent, {
            data: {
                idTypZaznamu: this.typZaznamuTextu.id,
                typPrace: typPrace
            },
            width: '850px'
        });

    if (this.dialogRef) {

      this.dialogRef.afterClosed().subscribe((result: DialogResult | undefined) => {
        if (!result) {
          return;
        }

        switch (this.typZaznamuTextu.id) {

          case this.ID_TYP_POCET_AKTUALNE_VEDENYCH_PRAC: {

            const name = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_BAKALARSKYCH
              + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[name] : result.pocetBakalarskychPrac});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_BAKALARSKYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : result.pocetBakalarskychPrac});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_BAKALARSKYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : result.pocetBakalarskychPrac});
              }

            }





            const name2 = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_DIPLOMOVYCH
              + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[name2] : result.pocetDiplomovychPrac});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_DIPLOMOVYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : result.pocetDiplomovychPrac});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_DIPLOMOVYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : result.pocetDiplomovychPrac});
              }

            }




            const name3 = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_DIZERTACNYCH
                + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[name3] : result.pocetDizertacnychPrac});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_DIZERTACNYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : result.pocetDizertacnychPrac});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_VEDENYCH_PRAC_DIZERTACNYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : result.pocetDizertacnychPrac});
              }

            }

            break;
          }



          case this.ID_TYP_POCET_OBHAJENYCH_PRAC: {
            //tieto polia su opakovania v skupine,
            // cize meno polozky vyzera takto: "name_-111_-110_0_SK", ale
            // vkladat text do polozky musime tak, ze do pola: "name_-110_SK" vlozime pole [text]

            // BAKALARCKE PRACE
            const name = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH
              + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[name] : [result.pocetBakalarskychPrac]});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : [result.pocetBakalarskychPrac]});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : [result.pocetBakalarskychPrac]});
              }

            }


            // DIPLOMOVE PRACE
            const name2 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH
              + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[name2] : [result.pocetDiplomovychPrac]});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : [result.pocetDiplomovychPrac]});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : [result.pocetDiplomovychPrac]});
              }

            }


            // DIZERTACNE PRACE
            const name3 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
              + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[name3] : [result.pocetDizertacnychPrac]});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : [result.pocetDizertacnychPrac]});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : [result.pocetDizertacnychPrac]});
              }

            }

            break;

          }

          case this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH: {

            const nameJazyk1 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH
                + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[nameJazyk1] : [result.pocetBakalarskychPrac]});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : [result.pocetBakalarskychPrac]});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : [result.pocetBakalarskychPrac]});
              }

            }


            break;

          }

          case this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH: {

            const nameJazyk1 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH
              + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[nameJazyk1] : [result.pocetDiplomovychPrac]});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : [result.pocetDiplomovychPrac]});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : [result.pocetDiplomovychPrac]});
              }

            }

            break;

          }

          case this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH: {

            const nameJazyk1 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
              + '_' + this.jazykFormulara1;

            this.formularFormGroup.patchValue({[nameJazyk1] : [result.pocetDizertacnychPrac]});

            if (this.jazykFormulara2) {
              const nameJazyk2 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
                + '_' + this.jazykFormulara2;

              this.formularFormGroup.patchValue({[nameJazyk2] : [result.pocetDizertacnychPrac]});

              if (this.jazykFormulara3) {
                const nameJazyk3 = 'name_' + this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
                  + '_' + this.jazykFormulara3;

                this.formularFormGroup.patchValue({[nameJazyk3] : [result.pocetDizertacnychPrac]});
              }

            }

            break;

          }

          default:
            break;

        }

        // this.spinner = true;
      });
    }



  }


  openZabezpecovanePredmetyDialog() {

    this.dialog2Ref = this.dialog.open(
        ProfiloveAOstatneZabezpecovanePredmetyDialogComponent, {
            data: {
                idTypZaznamu: this.typZaznamuTextu.id,
                maxPocetPredmetov: this.typZaznamuTextu.maxPocet,
                kodJazykFormulara: this.kodJazyk
            },
            width: '1000px'
        });


    if (this.dialog2Ref) {

      this.dialog2Ref.afterClosed().subscribe((result: Predmet[] | undefined) => {
        if (!result) {
          return;
        }

        let menoArraycontrolsuJazyk1 = null;
        let menoArraycontrolsuJazyk2 = null;
        let menoArraycontrolsuJazyk3 = null;
        if (this.typZaznamuTextu.idSkupina) {
          menoArraycontrolsuJazyk1 = 'name_' + this.typZaznamuTextu.idSkupina
            + '_' + this.jazykFormulara1;
        } else {
          menoArraycontrolsuJazyk1 = 'name_' + this.typZaznamuTextu.id
            + '_' + this.jazykFormulara1;
        }

        const formArrayJazyk1 = <FormArray>this.formularFormGroup.get(menoArraycontrolsuJazyk1);
        let formArrayJazyk2 = null;
        let formArrayJazyk3 = null;

        if (this.existujeVoFormulariJazyk2) {

          if (this.typZaznamuTextu.idSkupina) {
            menoArraycontrolsuJazyk2 = 'name_' + this.typZaznamuTextu.idSkupina
            + '_' + this.jazykFormulara2;
          } else {
            menoArraycontrolsuJazyk2 = 'name_' + this.typZaznamuTextu.id
            + '_' + this.jazykFormulara2;
          }

          formArrayJazyk2 = <FormArray>this.formularFormGroup.get(menoArraycontrolsuJazyk2);

          if (this.existujeVoFormulariJazyk3) {

            if (this.typZaznamuTextu.idSkupina) {
              menoArraycontrolsuJazyk3 = 'name_' + this.typZaznamuTextu.idSkupina
              + '_' + this.jazykFormulara3;
            } else {
              menoArraycontrolsuJazyk3 = 'name_' + this.typZaznamuTextu.id
              + '_' + this.jazykFormulara3;
            }

            formArrayJazyk3 = <FormArray>this.formularFormGroup.get(menoArraycontrolsuJazyk3);

          }

        }

        // vymazeme najprv celu skupinu predmetov vo formulari,
        // aby sme mohli vlozit nove predmety, ktore si ucitel vybral v dialogu

        formArrayJazyk1.reset();
        // neviem, ci toto tu vobec treba, ale pre istotu som to sem dal (to iste pre jazyky)
        // ked opravim automaticke pridavanie skupinovych poloziek, mozem to dat prec
        formArrayJazyk1.controls.length
          = this.pocetTypovVSkupine * this.typZaznamuTextu.minPocet;

        if (formArrayJazyk2) {
          formArrayJazyk2.reset();
          formArrayJazyk2.controls.length
            = this.pocetTypovVSkupine * this.typZaznamuTextu.minPocet;
          if (formArrayJazyk3) {
            formArrayJazyk3.reset();
            formArrayJazyk3.controls.length
              = this.pocetTypovVSkupine * this.typZaznamuTextu.minPocet;
          }
        }




        const predmety: Predmet[] = result;

        // Ak učiteľ vyberie viac ako je minimálny počet predmetov, tak sa
        // vo formulári pridajú tak akoby ich učiteľ pridal priamo na formulári.

        // metoda "pridatSkupinoveOpakovanie z formular.component.ts"
        // sa zavola len vtedy, ak je pocet predmetov z dialogu vacsi ako pocet casti skupiny
        // vo formulari (lebo co cast skupiny, to predmet),
        // a to bez ohladu na to, ci su vyplnene alebo prazdne,
        // lebo aj prazdne polozky sa pocitaju do poctu poloziek vo formulari

        const pocetCastiSkupinyJazyk1 = this.mapaJazykovAMapIdSkupinACastiSkupin?.
          get(this.jazykFormulara1)?.
          get(this.typZaznamuTextu.idSkupina)?.length || 0;

        //tu treba pre kazdy jazyk samostatny cyklus, lebo sa moze stat,
        // ze v jazyku 2 a 3 je iny pocet vyplnenych casti skupin ako v jazyku1
        for (let i = 0; i < predmety.length - pocetCastiSkupinyJazyk1; i++) {
          this.pridatSkupinoveOpakovanie.emit(this.jazykFormulara1);
        }

        if (this.existujeVoFormulariJazyk2) {

          const pocetCastiSkupinyJazyk2 = this.mapaJazykovAMapIdSkupinACastiSkupin?.
            get(this.jazykFormulara2)?.
            get(this.typZaznamuTextu.idSkupina)?.length || 0;

          for (let i = 0; i < predmety.length - pocetCastiSkupinyJazyk2; i++) {
            this.pridatSkupinoveOpakovanie.emit(this.jazykFormulara2);
          }

          if (this.existujeVoFormulariJazyk3) {

            const pocetCastiSkupinyJazyk3 = this.mapaJazykovAMapIdSkupinACastiSkupin?.
              get(this.jazykFormulara3)?.
              get(this.typZaznamuTextu.idSkupina)?.length || 0;

            for (let i = 0; i < predmety.length - pocetCastiSkupinyJazyk3; i++) {
              this.pridatSkupinoveOpakovanie.emit(this.jazykFormulara3);
            }
          }


        }

        // tu vyplnime vsetky polozky v skupine vo formulari predmetmi, ktore si ucitel vybral v dialogu
        // const pocetPoloziekNaVyplnenie = predmety.length * this.pocetTypovVSkupine;

        for (let i = 0; i < predmety.length; i++) {
          const predmet = predmety[i];
          const startIndex = i * this.pocetTypovVSkupine;


          // niekedy sa stane, ze mame vo formulari jednu cast skupiny vyplnenu a druhu nie
          //  (napriklad ked jednu z nich zmazem manualne).
          /// Vtedy vo formArray pre tu druhu nevyplnenu casat neexistuje control na danej pozicii, a teda
          // musime pridat novy control, aby sa dalo do neho vkladat

          // jazyk1
          formArrayJazyk1.at(startIndex) ? formArrayJazyk1.at(startIndex).patchValue(predmet.nazov)
            : formArrayJazyk1.push(new FormControl(predmet.nazov));

          formArrayJazyk1.at(startIndex + 1) ? formArrayJazyk1.at(startIndex + 1).patchValue(predmet.studProgramyPopisy)
            : formArrayJazyk1.push(new FormControl(predmet.studProgramyPopisy));

          formArrayJazyk1.at(startIndex + 2) ? formArrayJazyk1.at(startIndex + 2).patchValue(predmet.studProgramStupen)
            : formArrayJazyk1.push(new FormControl(predmet.studProgramStupen));

          const studOdbory = predmet.studOdboryPodprogramu ? predmet.studOdboryPodprogramu : predmet.studOdboryProgramu;
          formArrayJazyk1.at(startIndex + 3) ? formArrayJazyk1.at(startIndex + 3).patchValue(studOdbory)
              : formArrayJazyk1.push(new FormControl(studOdbory));



          if (formArrayJazyk2) {

            formArrayJazyk2.at(startIndex) ? formArrayJazyk2.at(startIndex).patchValue(predmet.nazovEN
              ? predmet.nazovEN : predmet.nazov)
              : formArrayJazyk2.push(new FormControl(predmet.nazovEN ? predmet.nazovEN : predmet.nazov));

            formArrayJazyk2.at(startIndex + 1) ? formArrayJazyk2.at(startIndex + 1).patchValue(predmet.studProgramyPopisyEN
              ? predmet.studProgramyPopisyEN : predmet.studProgramyPopisy)
              : formArrayJazyk2.push(new FormControl(predmet.studProgramyPopisyEN ? predmet.studProgramyPopisyEN : predmet.studProgramyPopisy));

            formArrayJazyk2.at(startIndex + 2) ? formArrayJazyk2.at(startIndex + 2).patchValue(predmet.studProgramStupen)
              : formArrayJazyk2.push(new FormControl(predmet.studProgramStupen));

            if (predmet.studOdboryPodprogramuEN || predmet.studOdboryProgramuEN) {
              formArrayJazyk2.at(startIndex + 3) ? formArrayJazyk2.at(startIndex + 3).patchValue(predmet.studOdboryPodprogramuEN
                ? predmet.studOdboryPodprogramuEN : predmet.studOdboryProgramuEN)
                : formArrayJazyk2.push(new FormControl(predmet.studOdboryPodprogramuEN ? predmet.studOdboryPodprogramuEN : predmet.studOdboryProgramuEN)) ;
            } else {
              // ak neexistuju jazykove mutacie, vlozime do jazyk2 to iste, co je v jazyk1
              formArrayJazyk2.at(startIndex + 3) ? formArrayJazyk2.at(startIndex + 3)
                .patchValue(formArrayJazyk1.at(startIndex + 3)?.value)
                : formArrayJazyk2.push(new FormControl(formArrayJazyk1.at(startIndex + 3)?.value)) ;
            }

            // jazyk3 (ak neexistuje jazyk2, neexistuje ani jazyk3)
            if (formArrayJazyk3) {

              formArrayJazyk3.at(startIndex) ? formArrayJazyk3.at(startIndex).patchValue(predmet.nazovHU
                ? predmet.nazovHU : predmet.nazov)
                : formArrayJazyk3.push(new FormControl(predmet.nazovHU ? predmet.nazovHU : predmet.nazov));

              formArrayJazyk3.at(startIndex + 1) ? formArrayJazyk3.at(startIndex + 1).patchValue(predmet.studProgramyPopisyHU
                ? predmet.studProgramyPopisyHU : predmet.studProgramyPopisy)
                : formArrayJazyk3.push(new FormControl(predmet.studProgramyPopisyHU ? predmet.studProgramyPopisyHU : predmet.studProgramyPopisy));

              formArrayJazyk3.at(startIndex + 2) ? formArrayJazyk3.at(startIndex + 2).patchValue(predmet.studProgramStupen)
                : formArrayJazyk3.push(new FormControl(predmet.studProgramStupen));

              if (predmet.studOdboryPodprogramuHU || predmet.studOdboryProgramuHU) {
                formArrayJazyk3.at(startIndex + 3) ? formArrayJazyk3.at(startIndex + 3).patchValue(predmet.studOdboryPodprogramuHU
                  ? predmet.studOdboryPodprogramuHU : predmet.studOdboryProgramuHU)
                  : formArrayJazyk3.push(new FormControl(predmet.studOdboryPodprogramuHU ? predmet.studOdboryPodprogramuHU : predmet.studOdboryProgramuHU));
              } else {
                // ak neexistuju jazykove mutacie, vlozime do jazyk3 to iste, co je v jazyk1
                formArrayJazyk3.at(startIndex + 3) ? formArrayJazyk3.at(startIndex + 3).patchValue(formArrayJazyk1.at(startIndex + 3)?.value)
                  : formArrayJazyk3.push(new FormControl(formArrayJazyk1.at(startIndex + 3)?.value));
              }

            }


          }


        }

      });

    }

  }


  getVyplnitUdajeTooltipText(idTyp: number) {

    if (this.ZOZNAM_ID_TYPOV_ZP_S_PREDVYPLNENIM.includes(idTyp)) {
      return this.getVyplnitPocetZaverecnychPracVAiS2Tooltip(idTyp);
    } else if (this.ZOZNAM_ID_TYPOV_PREDMETOV_S_VYPLNENIM.includes(idTyp)) {
      return this.getVyplnitUdajeOZabezpecovanychPredmetochTooltip(idTyp);
    }

  }


  getVyplnitPocetZaverecnychPracVAiS2Tooltip(idTyp: number) {

    let result = '';
    if (this.ZOZNAM_ID_TYPOV_OBHAJENYCH_PRAC.includes(idTyp)) {
      result = this.translateService.instant('Vyplniť počet obhájených prác v AiS2');
    } else {
      result = this.translateService.instant('Vyplniť počet vedených prác v AiS2');
    }
    return result;
  }

  getVyplnitUdajeOZabezpecovanychPredmetochTooltip(idTyp: number) {

    let result = '';
    if (idTyp === this.ID_TYP_PREHLAD_ZABEZPECOVANYCH_PROFILOVYCH_PREDMETOV) {
      result = this.translateService.instant('Vyplniť profilové predmety podľa študijných programov v AiS2');
    } else  if (idTyp === this.ID_TYP_PREHLAD_ZABEZPECOVANYCH_OSTATNYCH_PREDMETOV) {
      result = this.translateService.instant('Vyplniť zabezpečované ostatné predmety podľa študijných programov v AiS2');
    }
    return result;
  }

  zobrazitButtonPrePredvyplnenieUdajov(idTyp: number, kodJazykIteracia: string) : boolean {

    let result = false;

    if (
      ((this.ZOZNAM_ID_TYPOV_ZP_S_PREDVYPLNENIM.includes(idTyp)
      ||
      this.ZOZNAM_ID_TYPOV_PREDMETOV_S_VYPLNENIM.includes(idTyp)))
      && (this.kodJazyk.length === 2 ||  this.kodJazyk.startsWith(kodJazykIteracia) )) {
        // tato podmienka o riadok vyssie je tu preto, aby sa v pripade, ze je vo formulari
        //vybrana kombinacia jazykov, nezobrazoval button pre predvyplnenie dvakrat

        result = true;
      }

    return result;

  }




}
